import { api } from "@/lib/api";

export type CalendarFormat = "carrossel" | "reels" | "post" | "story";
export type CalendarPersona = "copywriter" | "social_media" | "market_analyst";

export type CalendarPostPlan = {
  date: string; // ISO YYYY-MM-DD
  title: string;
  format: CalendarFormat;
  channels: string[];
  agentPersona: CalendarPersona;
  brief: string;
};

export const calendarApi = {
  /** Extrai o plano estruturado de posts de um calendário editorial. */
  plan: (companyId: string, issueId: string) =>
    api.get<{ posts: CalendarPostPlan[]; costCents?: number; reason?: string }>(
      `/companies/${companyId}/issues/${issueId}/calendar-plan`,
    ),
  /** Cria as tarefas (uma por post) em lote. */
  createTasks: (companyId: string, issueId: string, posts: CalendarPostPlan[]) =>
    api.post<{ created: number; issues: Array<{ id: string; identifier: string | null }> }>(
      `/companies/${companyId}/issues/${issueId}/calendar-tasks`,
      { posts },
    ),
};
